import { useRouter } from '@/src/store/router/RouterProvider';
import { useAppStore, useWalletStore } from '@/src/store/global/index';
import { useSession } from 'next-auth/react';
import { useEffect, useRef, useState } from 'react';

export type NavigationProps = {
    isOpen?: boolean;
    onClick?: () => void;
};

export const useNavigation = (props: NavigationProps) => {
    const [isRefreshing, setIsRefreshing] = useState(true);
    useEffect(() => {
        setIsRefreshing(false);
    }, []);
    //--------------------------------------
    const { data: session, status } = useSession();
    const walletStore = useWalletStore();
    //--------------------------------------
    const appStore = useAppStore();
    //--------------------------------------
    const { isOpen, onClick } = props;
    //--------------------------------------
    const router = useRouter();
    const pathname = router.asPath;
    //--------------------------------------
    const loaderRef = useRef<HTMLDivElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);
    const [loaderPosition, setLoaderPosition] = useState({ left: 0, top: 0 });
    //--------------------------------------
    useEffect(() => {
        if (containerRef.current) {
            const lastChild = containerRef.current.parentElement as HTMLElement;
            if (lastChild) {
                const rect = lastChild.getBoundingClientRect();
                setLoaderPosition({
                    left: rect.right + 16, // Position it 10px after the last element
                    top: rect.top, // Align vertically
                });
            }
        }
    }, [containerRef.current, loaderRef.current, walletStore.isConnected, walletStore.info?.isWalletValidatedWithSignedToken , session, status]); // Runs when the container is updated
    //--------------------------------------
    return {
        session,
        status,
        appStore,
        walletStore,
        isOpen,
        onClick,
        pathname,
        isRefreshing,
        setIsRefreshing,
        loaderRef,
        containerRef,
        loaderPosition,
    };
    //--------------------------------------
};
